/* File: assets/hybrid-builder.js */

(function () {
  const root = document.querySelector("[data-builder]");
  if (!root) return;

  const variants = Array.isArray(window.__HYBRID_VARIANTS__) ? window.__HYBRID_VARIANTS__ : [];
  const maxAllowed = parseInt(root.getAttribute("data-max-allowed") || "5", 10);

  const form = document.getElementById("HybridAddToCartForm");
  if (!form) return;

  const variantIdInput = form.querySelector("[data-variant-id]");
  const optionSelects = Array.from(form.querySelectorAll("[data-option]"));

  const propCharmsSummary = form.querySelector('[data-prop="charms_summary"]');
  const propCharmsJson = form.querySelector('[data-prop="charms_json"]');
  const propEngravingJson = form.querySelector('[data-prop="engraving_json"]');

  const selectedWrap = form.querySelector("[data-selected]");
  const engravingWrap = form.querySelector("[data-engraving-container]");

  const thumbs = Array.from(root.querySelectorAll("[data-thumb]"));
  const mainImg = root.querySelector(".hybrid-media-main img");

  const state = {
    selectedCharms: [],
    engraving: {}
  };

  function moneyFromCents(cents) {
    try {
      const n = Number(cents) / 100;
      return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
    } catch (e) {
      return "";
    }
  }

  function updateMainImage(src) {
    if (!mainImg || !src) return;
    mainImg.src = src;
  }

  thumbs.forEach((btn) => {
    btn.addEventListener("click", () => {
      updateMainImage(btn.getAttribute("data-src"));
    });
  });

  function findVariantByOptions() {
    if (!optionSelects.length) return variants[0];

    const chosen = optionSelects.map((sel) => sel.value);
    const match = variants.find((v) => {
      const opts = [v.option1, v.option2, v.option3].filter(Boolean);
      if (opts.length !== chosen.length) return false;
      for (let i = 0; i < chosen.length; i++) {
        if (String(opts[i]) !== String(chosen[i])) return false;
      }
      return true;
    });

    return match || variants[0];
  }

  function syncBaseVariant() {
    const v = findVariantByOptions();
    if (!v) return;

    if (variantIdInput) variantIdInput.value = v.id;

    const cartDrawerTitle = root.querySelector(".h2");
    if (cartDrawerTitle && v.available === false) {
      cartDrawerTitle.setAttribute("data-unavailable", "true");
    }
  }

  optionSelects.forEach((sel) => sel.addEventListener("change", syncBaseVariant));
  syncBaseVariant();

  function isSelected(variantId) {
    return state.selectedCharms.some((x) => String(x.variantId) === String(variantId));
  }

  function addCharm(item) {
    if (state.selectedCharms.length >= maxAllowed) return false;
    if (isSelected(item.variantId)) return true;
    state.selectedCharms.push(item);
    return true;
  }

  function removeCharm(variantId) {
    state.selectedCharms = state.selectedCharms.filter((x) => String(x.variantId) !== String(variantId));
    delete state.engraving[String(variantId)];
  }

  function renderSelected() {
    if (!selectedWrap) return;

    const count = state.selectedCharms.length;

    let html = "";
    html += `<div class="small" style="margin-top:6px;font-weight:600;">Your selected charms (${count}/${maxAllowed})</div>`;

    if (!count) {
      html += `<p class="small" style="margin-top:6px;">No charms selected yet.</p>`;
      selectedWrap.innerHTML = html;
      return;
    }

    html += `<ul style="margin:8px 0 0 18px;">`;
    state.selectedCharms.forEach((c) => {
      const price = c.priceMoney || moneyFromCents(c.price);
      html += `
        <li style="margin:6px 0;">
          <span>${c.title} (${price})</span>
          <button type="button" data-remove="${c.variantId}" style="margin-left:10px;border:0;background:transparent;text-decoration:underline;cursor:pointer;">
            Remove
          </button>
        </li>
      `;
    });
    html += `</ul>`;

    if (count >= maxAllowed) {
      html += `
        <div style="margin-top:10px;border:1px solid rgba(0,0,0,.12);border-radius:10px;padding:10px;">
          <div class="small" style="font-weight:600;">Maximum reached.</div>
          <div class="small">You can select up to ${maxAllowed} charms. Remove one to add a different charm.</div>
        </div>
      `;
    }

    selectedWrap.innerHTML = html;

    selectedWrap.querySelectorAll("[data-remove]").forEach((btn) => {
      btn.addEventListener("click", () => {
        removeCharm(btn.getAttribute("data-remove"));
        renderSelected();
        renderEngraving();
        syncProperties();
        syncCardStates();
      });
    });
  }

  function renderEngraving() {
    if (!engravingWrap) return;

    const engraveables = state.selectedCharms.filter((c) => c.isEngraveable);

    if (!engraveables.length) {
      engravingWrap.innerHTML = `<p class="small">No engravable charms selected.</p>`;
      return;
    }

    let html = "";
    engraveables.forEach((c) => {
      const key = String(c.variantId);
      const rule = c.rule || {};
      const maxChars = parseInt(rule.maxCharacters || "12", 10);
      const casePolicy = rule.casePolicy || "keep";
      const required = !!rule.required;

      const current = state.engraving[key] || { text: "" };

      html += `
        <div style="margin-top:12px;border:1px solid rgba(0,0,0,.12);border-radius:12px;padding:12px;">
          <div style="font-weight:600;">Engraving for: ${escapeHtml(c.title)}</div>
          <div class="small" style="opacity:.75;margin-top:4px;">Max ${maxChars} characters</div>

          <input
            type="text"
            data-engrave-input="${key}"
            value="${escapeAttr(current.text || "")}"
            placeholder="Enter engraving"
            style="margin-top:10px;width:100%;padding:12px;border:1px solid rgba(0,0,0,.12);border-radius:10px;"
            ${required ? "required" : ""}
          >

          <div class="small" style="opacity:.75;margin-top:6px;">
            Case: ${escapeHtml(casePolicy)}
          </div>
        </div>
      `;
    });

    engravingWrap.innerHTML = html;

    engravingWrap.querySelectorAll("[data-engrave-input]").forEach((input) => {
      input.addEventListener("input", () => {
        const key = input.getAttribute("data-engrave-input");
        const charm = state.selectedCharms.find((x) => String(x.variantId) === String(key));
        if (!charm) return;

        const rule = charm.rule || {};
        const maxChars = parseInt(rule.maxCharacters || "12", 10);
        const casePolicy = rule.casePolicy || "keep";
        const allowedRegex = rule.allowedRegex || "";

        let val = input.value || "";

        if (allowedRegex) {
          try {
            const re = new RegExp(allowedRegex, "g");
            val = (val.match(re) || []).join("");
          } catch (e) {}
        }

        if (casePolicy === "force_upper") val = val.toUpperCase();
        if (casePolicy === "force_lower") val = val.toLowerCase();

        if (val.length > maxChars) val = val.slice(0, maxChars);

        input.value = val;

        state.engraving[String(key)] = { text: val };
        syncProperties();
      });
    });
  }

  function syncProperties() {
    const summary = state.selectedCharms
      .map((c) => `${c.title} (${c.priceMoney || moneyFromCents(c.price)})`)
      .join(", ");

    const charmsJson = state.selectedCharms.map((c) => ({
      productId: c.productId,
      variantId: c.variantId,
      title: c.title,
      price: c.price,
      isEngraveable: !!c.isEngraveable
    }));

    const engravingJson = Object.keys(state.engraving).map((variantId) => ({
      variantId,
      ...state.engraving[variantId]
    }));

    if (propCharmsSummary) propCharmsSummary.value = summary;
    if (propCharmsJson) propCharmsJson.value = JSON.stringify(charmsJson);
    if (propEngravingJson) propEngravingJson.value = JSON.stringify(engravingJson);
  }

  function syncCardStates() {
    const cards = Array.from(form.querySelectorAll("[data-charm]"));
    cards.forEach((card) => {
      const vid = card.getAttribute("data-variant-id");
      const selected = isSelected(vid);
      card.setAttribute("aria-pressed", selected ? "true" : "false");
      card.style.outline = selected ? "2px solid rgba(0,0,0,.35)" : "none";
    });
  }

  function onCharmClick(evt) {
    const btn = evt.target.closest("[data-charm]");
    if (!btn) return;

    const variantId = btn.getAttribute("data-variant-id");
    const productId = btn.getAttribute("data-product-id");
    const title = btn.getAttribute("data-title") || "";
    const price = parseInt(btn.getAttribute("data-price") || "0", 10);
    const priceMoney = btn.getAttribute("data-price-money") || moneyFromCents(price);

    const isEngraveable = String(btn.getAttribute("data-engraveable")) === "true";
    const rule = isEngraveable
      ? {
          maxCharacters: btn.getAttribute("data-max-characters") || "",
          maxLines: btn.getAttribute("data-max-lines") || "",
          casePolicy: btn.getAttribute("data-case-policy") || "keep",
          allowedRegex: btn.getAttribute("data-allowed-regex") || "",
          required: String(btn.getAttribute("data-required")) === "true"
        }
      : null;

    if (isSelected(variantId)) {
      removeCharm(variantId);
    } else {
      const ok = addCharm({
        productId,
        variantId,
        title,
        price,
        priceMoney,
        isEngraveable,
        rule
      });

      if (!ok) {
        renderSelected();
        return;
      }
    }

    renderSelected();
    renderEngraving();
    syncProperties();
    syncCardStates();
  }

  form.addEventListener("click", onCharmClick);

  renderSelected();
  renderEngraving();
  syncProperties();
  syncCardStates();

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function escapeAttr(str) {
    return escapeHtml(str).replaceAll("`", "&#096;");
  }
})();

/* assets/hybrid-builder.js
   Sync variant selectors (Color Size) with gallery thumbnails and selected variant
*/

(function () {
  const section = document.querySelector('.hybrid-builder[data-builder]');
  if (!section || !window.__HYBRID_VARIANTS__) return;

  const variants = Array.isArray(window.__HYBRID_VARIANTS__) ? window.__HYBRID_VARIANTS__ : [];
  const form = section.querySelector('#HybridAddToCartForm');
  if (!form) return;

  const optionSelects = Array.from(section.querySelectorAll('select[data-option-index]'))
    .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));

  const variantIdInput = form.querySelector('input[data-variant-id], input[data-variant-id], input[name="id"]');
  const priceWrap = section.querySelector('[data-base-price]');
  const thumbs = Array.from(section.querySelectorAll('.hybrid-thumb[data-media-id]'));

  const mainImg = (function findMainImg() {
    const imgs = Array.from(section.querySelectorAll('img'));
    const thumbImgs = new Set(Array.from(section.querySelectorAll('.hybrid-thumb img')));
    const candidate = imgs.find((img) => !thumbImgs.has(img));
    return candidate || null;
  })();

  function moneyFromTheme(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) {}
    const n = Number(cents || 0) / 100;
    return n.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  }

  function getSelectedOptions() {
    return optionSelects.map((s) => s.value);
  }

  function findVariantByOptions(optionsArr) {
    return variants.find((v) => {
      const vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
      if (vOpts.length !== optionsArr.length) return false;
      for (let i = 0; i < optionsArr.length; i++) {
        if (String(vOpts[i]) !== String(optionsArr[i])) return false;
      }
      return true;
    });
  }

  function findVariantByMediaId(mediaId) {
    const idStr = String(mediaId);
    // Shopify variant JSON commonly has featured_media.id or featured_image.id
    return (
      variants.find((v) => v.featured_media && String(v.featured_media.id) === idStr) ||
      variants.find((v) => v.featured_image && String(v.featured_image.id) === idStr) ||
      null
    );
  }

  function setSelectsFromVariant(variant) {
    if (!variant) return;
    const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    optionSelects.forEach((sel, idx) => {
      if (opts[idx] != null && sel.value !== opts[idx]) sel.value = opts[idx];
    });
  }

  function setMainImageFromThumb(mediaId) {
    if (!mainImg) return;

    const btn = section.querySelector(`.hybrid-thumb[data-media-id="${CSS.escape(String(mediaId))}"]`);
    if (!btn) return;

    const thumbImg = btn.querySelector('img');
    if (!thumbImg) return;

    if (thumbImg.getAttribute('src')) mainImg.setAttribute('src', thumbImg.getAttribute('src'));
    if (thumbImg.getAttribute('srcset')) mainImg.setAttribute('srcset', thumbImg.getAttribute('srcset'));
    if (thumbImg.getAttribute('sizes')) mainImg.setAttribute('sizes', thumbImg.getAttribute('sizes'));
    if (thumbImg.getAttribute('alt')) mainImg.setAttribute('alt', thumbImg.getAttribute('alt'));

    // simple active style
    thumbs.forEach((t) => t.classList.remove('is-active'));
    btn.classList.add('is-active');
  }

  function setMainImageFromVariant(variant) {
    if (!variant) return;
    const mediaId = (variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id);
    if (mediaId) setMainImageFromThumb(mediaId);
  }

  function updatePrice(variant) {
    if (!priceWrap || !variant) return;

    const price = moneyFromTheme(variant.price);
    const compare = variant.compare_at_price && variant.compare_at_price > variant.price ? moneyFromTheme(variant.compare_at_price) : null;

    if (compare) {
      priceWrap.innerHTML =
        `<span style="text-decoration:line-through;opacity:.6;margin-right:8px;">${compare}</span>` +
        `<span>${price}</span>`;
    } else {
      priceWrap.textContent = price;
    }
  }

  function setVariant(variant, opts) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    updatePrice(variant);

    // keep selectors in sync
    if (opts && opts.syncSelects) setSelectsFromVariant(variant);

    // keep gallery in sync
    if (opts && opts.syncImage) setMainImageFromVariant(variant);

    // trigger a change event so any theme scripts listening can react
    try {
      form.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }

  // When dropdowns change -> update variant + image
  function onOptionsChange() {
    const selected = getSelectedOptions();
    const variant = findVariantByOptions(selected);
    if (variant) setVariant(variant, { syncSelects: false, syncImage: true });
  }

  optionSelects.forEach((sel) => sel.addEventListener('change', onOptionsChange));

  // When user clicks a thumbnail -> change variant to match that image (if possible) AND update selects
  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      const mediaId = btn.getAttribute('data-media-id');
      setMainImageFromThumb(mediaId);

      const v = findVariantByMediaId(mediaId);
      if (v) setVariant(v, { syncSelects: true, syncImage: false });
    });
  });

  // Init: match current selects -> variant -> image
  (function init() {
    const v = findVariantByOptions(getSelectedOptions());
    if (v) setVariant(v, { syncSelects: true, syncImage: true });
  })();
})();

/* PASTE THIS into assets/hybrid-builder.js
Put it near the bottom, after your existing builder logic is defined.
It only controls category icons, filter bar, and search.
It does not change your add to cart logic.
*/

(function () {
  function iconSvg(key) {
    var k = (key || "").toLowerCase().trim();

    if (k === "__all") {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7h16M4 12h16M4 17h16"/></svg>';
    }
    if (k.includes("love") || k.includes("heart")) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
    }
    if (k.includes("nature") || k.includes("leaf") || k.includes("tree")) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 3S10 3 6 7s-4 14-4 14 10 0 14-4 4-14 4-14z"/><path d="M7 17c3-3 7-7 10-10"/></svg>';
    }
    if (k.includes("faith") || k.includes("cross")) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v20"/><path d="M6 7h12"/></svg>';
    }
    if (k.includes("birth") || k.includes("stone") || k.includes("gem")) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l6 6-6 14L6 8l6-6z"/><path d="M6 8h12"/></svg>';
    }
    if (k.includes("symbol") || k.includes("icon")) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l3 7h7l-5.5 4 2 7-6.5-4.5L5.5 20l2-7L2 9h7l3-7z"/></svg>';
    }

    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M8 12h8"/></svg>';
  }

  function normalize(s) {
    return (s || "").toLowerCase().trim();
  }

  function initCharmFilters(root) {
    var toolbar = root.querySelector("[data-hybrid-charms-toolbar]");
    var filtersWrap = root.querySelector("[data-hybrid-charm-filters]");
    var searchInput = root.querySelector("[data-hybrid-charm-search]");
    var results = root.querySelector("[data-hybrid-charms-results]");

    if (!toolbar || !filtersWrap || !searchInput || !results) return;

    /* inject icons */
    var iconHolders = filtersWrap.querySelectorAll("[data-icon]");
    iconHolders.forEach(function (el) {
      el.innerHTML = iconSvg(el.getAttribute("data-icon"));
    });

    function apply() {
      var activeBtn = filtersWrap.querySelector(".hybrid-filter-pill.is-active");
      var active = activeBtn ? normalize(activeBtn.getAttribute("data-filter")) : "__all";
      var q = normalize(searchInput.value);

      var cards = results.querySelectorAll("[data-charm]");
      var blocks = results.querySelectorAll("[data-category-block]");

      cards.forEach(function (card) {
        var cat = normalize(card.getAttribute("data-charm-category"));
        var title = normalize(card.getAttribute("data-charm-title"));

        var passCat = (active === "__all") || (cat === active);
        var passSearch = !q || title.includes(q);

        card.classList.toggle("hybrid-hidden", !(passCat && passSearch));
      });

      /* hide empty category blocks */
      blocks.forEach(function (block) {
        var visibleCard = block.querySelector("[data-charm]:not(.hybrid-hidden)");
        block.classList.toggle("hybrid-hidden", !visibleCard);
      });
    }

    filtersWrap.addEventListener("click", function (e) {
      var btn = e.target.closest(".hybrid-filter-pill");
      if (!btn) return;

      filtersWrap.querySelectorAll(".hybrid-filter-pill").forEach(function (b) {
        b.classList.remove("is-active");
        b.setAttribute("aria-selected", "false");
      });

      btn.classList.add("is-active");
      btn.setAttribute("aria-selected", "true");
      apply();
    });

    var t;
    searchInput.addEventListener("input", function () {
      window.clearTimeout(t);
      t = window.setTimeout(apply, 60);
    });

    apply();
  }

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector(".hybrid-builder") || document;
    initCharmFilters(root);
  });
})();
